export const seriesName = {
  [1]: '小智报表-展示端',
  [2]: '小智报表-设计器',
  [101]: '小智BI-展示端',
  [102]: '小智BI-设计器',
  [201]: '小智API服务',
};

export const version = {
  [1]: '免费版',
  [2]: '基础版',
  [3]: '标准版',
  [4]: '高级版',
};

export const getseriesNameOption = () => {
  let seriesNameOption = [];

  for (const key in seriesName) {
    seriesNameOption.push({
      name: seriesName[key],
      value: Number(key),
    });
  }
  return seriesNameOption;
};

export const getVersionOption = () => {
  let versionOption = [];

  for (const key in version) {
    versionOption.push({
      name: version[key],
      value: Number(key),
    });
  }
  /* 去除免费版 */
  versionOption = versionOption.filter((i) => i.value !== 1);
  return versionOption;
};

export const getUpgradeVersion = (version) => {
  const result = [];
  for (const key in version) {
    if (key > version) {
      result.push({ name: version[key], value: Number(key) });
    }
  }
  return result;
};

export const extractYearFromDates = (dates) => {
  return dates.map((date, index) => {
    // const startTime = date.start_time.substring(0, 4);
    // const endTime = date.end_time.substring(0, 4);
    return {
      value: {
        start_time: date.start_time,
        end_time: date.end_time,
        index: index
      },
      name:`${date.start_time} - ${date.end_time}`,
    };
  });
}



// WEBPACK FOOTER //
// ./src/components/agileFlow/utils.js